import { Theme } from '@mui/material';
import styled from '@emotion/styled';

import { Accordion, AccordionDetails } from '@mui/material';

type ParamsStyle = {
    theme?: Theme;
}

export const AccordionCustom = styled(Accordion)(
    ({ theme }: ParamsStyle) => `
        width: 100%;
        border: none;
        box-shadow: none;
        border-radius: 0px !important;
        padding-bottom: .8rem;

        ::before {
            display: none;
        }

        &.Mui-expanded {
            margin: 0rem;
        }
        
        #panel1d-header {
            min-height: 0;
            height: auto;
            padding: 0 0 .3rem 0;
            border-bottom: 1px solid #0C1C33;

            &.Mui-expanded {
                min-height: 0;
            }

            .MuiAccordionSummary-content {
                margin: 0;
                &.Mui-expanded {
                    margin: 0;
                }
            } 
        }

        .MuiAccordionSummary-expandIconWrapper {
            svg {
                width: auto;
                height: 1.2rem;
            }
        }

        @media(min-width: ${theme?.breakpoints.values.md}px) {
            width: 100%;
        }
`);

export const AccordionDetailsCustom = styled(AccordionDetails)(
    ({ theme }: ParamsStyle) => `
        width: 100%;
        display: flex;
        padding: 1.5625rem 0 0;
        justify-content: center;

        .store-link {
          font-weight: bold;
        }

        table {
          display: block;
          border-collapse: collapse;
          max-width: 90vw;
          overflow-x: scroll;
          width: 100%;
          margin: 1.5rem 0;

          tr,th,td {
            border: 1px solid black;
            text-align: center;
            padding: 0.5rem;
          }

          th {
            background-color: #0c1c33;
            color: white;
          }
        }

        ul {
          margin: 1rem;
          list-style-type: lower-alpha;
        }

        a {
            text-decoration: none;
            color: ${theme?.palette.primary.main};
        }

        @media(min-width: ${theme?.breakpoints.values.md}px) {
            padding-top: 1.1875rem;
        }
`);

export const LinkExternal = styled('a')(
    ({ theme }: ParamsStyle) => `
    font-size: .625rem;
    font-style: normal;
    font-weight: 600;
    text-decoration: none;
    color: ${theme?.palette.primary.main};
    margin: .8rem auto 0;
    svg {
        margin-left: .63rem;
    }
`);

export const BoxBanner = styled('div')(
    ({ theme }: ParamsStyle) => `
    width: 100%;
    max-width: 100%;
    display: none;
    flex-direction: column;
    align-items: flex-start;
    padding-bottom: 1.5rem;

    @media(min-width: ${theme?.breakpoints.values.md}px) {
        width: auto;
        display: flex;
        max-width: 14.5rem;
        padding-bottom: 0;
    }
`);

export const ContentShopping = styled.div(
    ({ theme }: ParamsStyle) => `
    width: 100%;
    display: flex;
    justify-content: flex-end;

    @media(min-width: ${theme?.breakpoints.values.md}px) {
        width: 30%;
        max-width: 20.875rem;
        padding-top: 1.27rem;
        min-height: calc(100vh - 4rem);
        border-top: 1px solid rgba(141, 155, 181, 0.5);
    }
`);